export const MAX_BADGE_SIZE = 99;
